export enum LocaleType {
  sv = "sv",
  en = "en",
}
